import { SelectListItem } from '@resources/js/typings/viewModels/selectListItemViewModel';
import React from 'react';
import LinkWrapper from '../LinkWrapper/LinkWrapper';

export default function SelectLinkOptionWrapper({
  option,
  children,
}: {
  option: SelectListItem<string | number | null>;
  children: React.ReactNode;
}): JSX.Element {
  return option.url ? (
    // We know the Select component will set the href
    <LinkWrapper href={option.url} scroll={false}>
      <span>{children}</span>
    </LinkWrapper>
  ) : (
    <>{children}</>
  );
}
